// extracted by mini-css-extract-plugin
module.exports = {"SliderSection":"ProductHomeSlider_SliderSection__23cHM","sliderTitleHolder":"ProductHomeSlider_sliderTitleHolder__2g3Zs"};